import { updatePdlPage, updatePdlUser, triggerOmnitureEvent } from '@bingads-webui-campaign/global-app-init';

export function omniturePageLoad({
  pageId,
  pageTitle,
  isSignUp = false,
  signUpPrefix = 'wizard_signup_step_',
}) {
  const navLevel3 = isSignUp ? `${signUpPrefix}${pageId}` : pageId;
  updatePdlPage({
    navLevel3,
    navLevel3Title: pageTitle,
  });
}

export const omnitureAccountUpdated = ({
  serverContext,
}) => {
  const {
    CurrentAccount,
  } = serverContext;

  updatePdlUser(serverContext);

  triggerOmnitureEvent({
    user: {
      aid: CurrentAccount.Id,
      cid: CurrentAccount.AdvertiserCustomerID,
      accountMode: CurrentAccount.AccountMode,
    },
  });
};
